import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Columns, Column, Button } from '@resurs/midas-react'
import { captureMessage } from '@sentry/react'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import { actOnData } from '../../../../util/helpers'
import { getErrorCodeAndMessage } from '../../models/paymentengine-error-models'
import { errorAnimation } from '../../../../assets/animations'

const ErrorPage = ({ data, onCancel, onNext }) => {
  const errorCodeAndMessage = getErrorCodeAndMessage(
    data.current.fatalErrorMessage,
  )
  useEffect(() => {
    captureMessage('Apply error', 'warning')
  })
  return (
    <>
      <PageWrapper type="danger">
        <div
          style={{
            padding: '2rem',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ display: 'flex' }}>
            <img
              style={{ margin: '1rem 1rem 1rem 0' }}
              src={errorAnimation}
              alt="Error animation"
            />
            <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
              {getText('payApply.paymentError.title')}
            </h4>
          </div>
          <Columns>
            <Column col6>
              <div style={{ paddingRight: '4rem' }}>
                {getText('payApply.paymentError.errorMsg')}
              </div>
              <div style={{ marginTop: '3rem' }}>
                {getText('errors.errorCode')}
                {actOnData(errorCodeAndMessage, ({ code, message }) => (
                  <>
                    {code}
                    <br />
                    {message}
                  </>
                ))}
              </div>
            </Column>
            <Column col6>
              <Columns>
                <Column col12 noPadding>
                  {getText('payApply.paymentError.support.title')}
                </Column>
                <Column col12 />
                <Column col6 noPadding>
                  {getText('payApply.paymentError.support.phone.title')}
                </Column>
                <Column col6 noPadding>
                  {getText('payApply.paymentError.support.phone.number')}
                </Column>
                <Column col6 noPadding>
                  {getText('payApply.paymentError.support.open.title')}
                </Column>
                <Column col6 noPadding>
                  {getText('payApply.paymentError.support.open.hours')
                    .split(',')
                    .map(text => (
                      <div key={text}>{text}</div>
                    ))}
                </Column>
              </Columns>
            </Column>
          </Columns>
        </div>
      </PageWrapper>
      <PageWrapper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '2rem',
          }}
        >
          <Button id="error-restart-btn" onClick={() => onCancel()}>
            {getText('payApply.restart')}
          </Button>
          <Button
            id="error-logout-btn"
            type="primary"
            onClick={() => {
              onNext()
            }}
          >
            {getText('payApply.logout')}
          </Button>
        </div>
      </PageWrapper>
    </>
  )
}

ErrorPage.propTypes = {
  data: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
}

export default ErrorPage
